import ReducerCreator from '../registerReducer';
import { buildStoreItem } from '../storeItemBuilder';
import * as TRIGGERS from './triggers.constants';
import { ITrigger as Trigger } from '../../models';
import { StoreItem } from '../Store';
import { APPLICATION_DISCONNECTED } from '../application/application.constants';

const r = new ReducerCreator<Trigger>()
    .register<void>(TRIGGERS.TRIGGERS_LOAD, (state) => {
        return (Object as any).assign({}, state, { isLoading: true, isLoaded: false, hasError: false, error: null });
    })
    .register<Trigger[]>(TRIGGERS.TRIGGERS_LOAD_SUCCESS, (state, payload) => {
        const newState = buildStoreItem(payload);
        return newState;
    })
    .register<any>(TRIGGERS.TRIGGERS_LOAD_ERROR, (state, payload) => {
        return (Object as any).assign({}, state, { isLoading: false, isLoaded: false, hasError: true, error: payload });
    })
    .register<void>(TRIGGERS.TRIGGER_ADD, (state) => {
        return (Object as any).assign({}, state, { isLoading: true, isLoaded: false, hasError: false, error: null });
    })
    .register<Trigger>(TRIGGERS.TRIGGER_ADD_SUCCESS, (state, payload) => {
        const newState: StoreItem<Trigger> = (Object as any).assign({}, state, { isLoading: false, isLoaded: true, hasError: false, error: null });
        newState.dictionary[payload.guid] = payload;
        return newState;
    })
    .register<any>(TRIGGERS.TRIGGER_ADD_ERROR, (state, payload) => {
        return (Object as any).assign({}, state, { isLoading: false, isLoaded: false, hasError: true, error: payload });
    })
    .register<void>(TRIGGERS.TRIGGER_UPDATE, (state) => {
        return (Object as any).assign({}, state, { isLoading: true, isLoaded: false, hasError: false, error: null });
    })
    .register<Trigger>(TRIGGERS.TRIGGER_UPDATE_SUCCESS, (state, payload) => {
        const newState: StoreItem<Trigger> = (Object as any).assign({}, state, { isLoading: false, isLoaded: true, hasError: false, error: null });
        newState.dictionary[payload.guid] = payload;
        return newState;
    })
    .register<any>(TRIGGERS.TRIGGER_UPDATE_ERROR, (state, payload) => {
        return (Object as any).assign({}, state, { isLoading: false, isLoaded: false, hasError: true, error: payload });
    })
    .register<void>(TRIGGERS.TRIGGER_DELETE, (state) => {
        return (Object as any).assign({}, state, { isLoading: true, isLoaded: false, hasError: false, error: null });
    })
    .register<Trigger>(TRIGGERS.TRIGGER_DELETE_SUCCESS, (state, payload) => {
        const newState: StoreItem<Trigger> = (Object as any).assign({}, state, { isLoading: false, isLoaded: true, hasError: false, error: null });
        const { dictionary } = newState;
        delete dictionary[payload.guid];
        return newState;
    })
    .register<any>(TRIGGERS.TRIGGER_DELETE_ERROR, (state, payload) => {
        return (Object as any).assign({}, state, { isLoading: false, isLoaded: false, hasError: true, error: payload });
    })
    .register<any>(APPLICATION_DISCONNECTED, () => {
        return new StoreItem<Trigger>();
    });

export function triggersReducer(state: StoreItem<Trigger> = new StoreItem<Trigger>(), action: { type: string, payload: any }) {
    return r.reduce(state, action);
}
